import { useState, useEffect } from 'react';

export interface Toast {
  id: number;
  kind: 'success' | 'error' | 'info';
  message: string;
}

const listeners = new Set<(toasts: Toast[]) => void>();
let toasts: Toast[] = [];
let nextId = 1;

export function showToast(kind: Toast['kind'], message: string, durationMs = 4000) {
  const id = nextId++;
  const t: Toast = { id, kind, message };
  toasts = [...toasts, t];
  listeners.forEach(l => l(toasts));
  setTimeout(() => {
    toasts = toasts.filter(x => x.id !== id);
    listeners.forEach(l => l(toasts));
  }, durationMs);
}

export function useToast() {
  const [list, setList] = useState<Toast[]>(toasts);
  useEffect(() => {
    listeners.add(setList);
    return () => { listeners.delete(setList); };
  }, []);
  return list;
}
